module.exports = __webpack_public_path__ + "img/Calendar.cbd97036.svg";